<template>
  <table class="table table-bordered">

    <thead>
      <tr>
        <th>Id</th>
        <th>Ticker</th>
        <th>Name</th>
        <th></th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="coin in currencies">
        <td>{{ coin.id }}</td>
        <td>{{ coin.symbol }}</td>
        <td>{{ coin.name }}</td>
        <td class="text-center">
            <b-btn size="sm" class="btn btn-sm" variant="" @click="onDelete(coin)"><span class="grey">remove</span></b-btn>
        </td>
      </tr>
    </tbody>

  </table>
</template>

<script>
export default {
  props: ['currencies'],
  methods: {
    onDelete(coin) {
      let ans
      if (coin.intransactions) {
        ans = confirm('There are transactions involving ' + coin.name + '!\nAre you sure you want to delete this currency?')
      } else {
        ans = confirm('Are you sure you want to delete ' + coin.name + '?')
      }
      if (!ans) {
        return
      }
      this.loading = true
      this.$store.dispatch('deleteCurrency', coin.id)
        .then(res => {
          if (res) {
            this.$emit('onMessage', coin.name + ' was deleted.')
          } else {
            alert('Error')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/components/tables/CurrenciesTable.vue